<template>
  <div class="app-root" :class="{ 'light-theme': isLight }">
    <button class="theme-toggle" @click="toggleTheme" :title="isLight ? '切换暗色' : '切换亮色'" :aria-label="isLight ? '切换到暗色主题' : '切换到亮色主题'">
      {{ isLight ? '🌙' : '☀️' }}
    </button>
    <router-view v-slot="{ Component, route }">
      <transition name="page" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const isLight = ref(false)

function toggleTheme() {
  isLight.value = !isLight.value
  document.documentElement.classList.toggle('light-theme', isLight.value)
  localStorage.setItem('wolfmio_theme', isLight.value ? 'light' : 'dark')
}

onMounted(() => {
  const saved = localStorage.getItem('wolfmio_theme')
  if (saved === 'light') {
    isLight.value = true
    document.documentElement.classList.add('light-theme')
  }
})
</script>

<style scoped>
.app-root {
  min-height: 100vh;
  background: var(--bg-primary);
  position: relative;
  transition: background var(--transition-normal);
}

.app-root::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(ellipse at 20% 50%, rgba(201, 169, 110, 0.04) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 20%, rgba(52, 152, 219, 0.03) 0%, transparent 50%),
    radial-gradient(ellipse at 50% 80%, rgba(231, 76, 60, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 15% 15%, rgba(255, 255, 255, 0.012) 0%, transparent 8%),
    radial-gradient(circle at 75% 65%, rgba(255, 255, 255, 0.01) 0%, transparent 6%),
    radial-gradient(circle at 40% 85%, rgba(0, 0, 0, 0.02) 0%, transparent 10%),
    radial-gradient(circle at 90% 40%, rgba(0, 0, 0, 0.015) 0%, transparent 7%);
  pointer-events: none;
  z-index: 0;
}

.theme-toggle {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: transform var(--transition-fast), border-color var(--transition-fast), background var(--transition-fast);
  box-shadow: var(--shadow-sm);
}

.theme-toggle:hover {
  transform: scale(1.1);
  border-color: var(--accent-gold);
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
